export function isJpegFile(file) {
  if (!file) {
    return false;
  }
  const type = String(file.type || "").toLowerCase();
  if (type === "image/jpeg" || type === "image/jpg") {
    return true;
  }
  const name = String(file.name || "").toLowerCase();
  return name.endsWith(".jpg") || name.endsWith(".jpeg");
}

export function readJpegFile(file, onLoad, input) {
  if (!file) {
    return;
  }
  if (!isJpegFile(file)) {
    if (input) {
      input.value = "";
    }
    window.alert("Only JPEG images are allowed");
    return;
  }
  const reader = new FileReader();
  reader.onload = () => {
    onLoad(reader.result);
  };
  reader.readAsDataURL(file);
}
